import { c as _c } from "react/compiler-runtime";
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface HelpCenterLinkProps {
  link: string;
  integration: string;
}
const HelpCenterLink = t0 => {
  const $ = _c(8);
  const {
    link,
    integration
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== integration) {
    t1 = {
      integration
    };
    $[0] = integration;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t || $[3] !== t1) {
    t2 = <TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={t1} />;
    $[2] = t;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== link || $[6] !== t2) {
    t3 = <a className="primary-link" href={link} target="_blank" rel="noreferrer">{t2}</a>;
    $[5] = link;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default HelpCenterLink;